/**
 * EmptyState Component
 *
 * Zero-data state with optional action. Uses glass-subtle CSS class
 * that auto-adapts to dark theme inside .theme-admin.
 */

import React, { ReactNode } from 'react';
import { Button } from './Button';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className = '',
}) => {
  return (
    <div
      className={`glass-subtle text-center py-12 px-6 rounded-2xl ${className}`}
    >
      {icon && (
        <div className="mx-auto w-16 h-16 rounded-full bg-[#111111]/8 flex items-center justify-center mb-4 text-[#1A1A1A]/40">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-1">{title}</h3>
      {description && (
        <p className="text-[var(--text-secondary)] max-w-sm mx-auto">{description}</p>
      )}
      {action && (
        <div className="mt-6">
          <Button onClick={action.onClick}>
            {action.label}
          </Button>
        </div>
      )}
    </div>
  );
};
